/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ProviderPropertyResponseDTO = {
    id?: number;
    propertyName?: string;
    propertyValue?: string;
    provider?: ProviderPropertyResponseDTO.provider;
};

export namespace ProviderPropertyResponseDTO {

    export enum provider {
        OKHI = 'Okhi',
        SMILE = 'Smile',
        DOJAH = 'Dojah',
    }


}
